import * as helper from '@/store/helpers'
import { defineStore } from 'pinia'

export const usePartnersStore = defineStore('partners', {
    state() {
        return {
            allPartners: []
        }
    },
    actions: {
        async getPartners(start, end, searchString = '') {
            const data = {
                start,
                end,
                search_string: searchString
            }

            this.allPartners = await helper.api('GET', '/partners', data)
        }
    }
})
